/* global JQuery */
import { Badge2, BadgeType2, DialogInfo2, ModalDialogType2, Widget2 } from 'bambooo';
export class ReactionDisplay extends Widget2 {
    constructor(element, sighting, mencates) {
        super({ element: jQuery('<span/>') });
        let reactionName = 'not set';
        if (sighting.reaction_id) {
            const encCate = mencates.get(sighting.reaction_id);
            if (encCate) {
                reactionName = encCate.name;
            }
        }
        this._badge = new Badge2({ text: `${reactionName}`, type: BadgeType2.secondary });
        this._badge.appendTo(ReactionDisplay._asParent(element));
        this._element = this._badge.getElement();
        const tooltpSpecStr = 'Click for more Information';
        this._element.attr('data-bs-toggle', 'tooltip');
        this._element.attr('data-html', 'true');
        this._element.attr('data-original-title', tooltpSpecStr);
        this._element.css({
            cursor: 'pointer'
        });
        this._element.on('click', () => {
            let infoStr = '';
            for (const [, value] of mencates) {
                if (!value.isdeleted) {
                    infoStr += `<b>${value.name}</b>:&nbsp;${value.description}<br><br>`;
                }
            }
            DialogInfo2.info('sightspeciesinfo', ModalDialogType2.xlarge, `REACTION Definitions: [${reactionName}] by Sighting #${sighting.id}`, infoStr, (_, modal) => {
                modal.hide();
            });
        });
    }
    /**
     * Resolve a parent (bambooo component, jQuery or selector) to a jQuery
     * handle the badge can be appended to.
     * @param {ComponentType} element
     * @return {JQuery}
     * @protected
     */
    static _asParent(element) {
        const maybe = element;
        if (maybe && typeof maybe.getElement === 'function') {
            return maybe.getElement();
        }
        return jQuery(element);
    }
}
